exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bindingLogin[data-v-336f4cea]{position:absolute;height:100%;width:100%;top:0;left:0;background:#fff!important;padding:.3rem}.bindingLogin>div[data-v-336f4cea]{width:4rem;height:1.6rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}.bindingLogin>div .login-loading[data-v-336f4cea]{width:1.6rem;height:1.6rem;margin:0 auto}.bindingLogin>div p[data-v-336f4cea]{line-height:1rem;font-size:.28rem;color:#409eff}", ""]);

// exports
